import { ClaimType } from './claimType';
import { RoleType } from './roleType';

export class DecodedJwt {
    constructor() {}

    email: string;
    employeeId: number;
    claimNames: ClaimType[];
    claimIds: string[];
    requirePasswordReset: string; //True / False
    multiFactorAuthPreference: string; // Email / Text Message
    requireMultiFactorAuthSetup: string // True / False
    requireMultiFactorAuth: string; //True / False
    passwordIsExpired: string // True / False
    // userType is either employee or customer
    userType: string;
    id: number;
    roles: RoleType[];
    exp: number;
    name: string;
}
